<template>
  <div class="glossary">
    <template v-if="mx$glossaryItems.length < 1">
      <v-card class="mb-6 card-root pa-4" elevation="0">
        <div class="expansion-panel-content">
          No items were found matching your search request. Please try another
          search.
        </div>
      </v-card>
    </template>
    <v-expansion-panels
      v-if="mx$glossaryItems.length > 0"
      v-model="expandedPanels"
      :multiple="true"
      class="d-flex flex-column"
    >
      <div class="glossary__search-result">
        <h2
          v-if="!glossarySearchIsLetter && glossarySearch"
          class="glossary__title glossary__search-result pl-0"
        >
          Search results containing "{{ glossarySearch }}"
        </h2>
      </div>
      <div class="d-flex flex-column" v-for="(item, i) in mx$glossaryItems" :key="i">
        <v-card class="card-root" elevation="0">
          <v-card-title class="d-flex align-center card-title-container">
            <span class="glossary__index">
              {{ item.name }}
            </span>
          </v-card-title>
          <v-expansion-panel
            v-for="content in item.contents"
            :key="content.id"
            class="panel"
          >
            <v-expansion-panel-header @click="handleClickPanel(content.id)">
              <h2 class="expansion-panel-title">{{ content.name }}</h2>
              <template v-slot:actions>
                <v-icon color="primary"> mdi-chevron-down </v-icon>
              </template>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <div v-html="content.body" class="expansion-panel-content" />
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-card>
      </div>
    </v-expansion-panels>
  </div>
</template>

<script>
import { SEGMENT_EVENTS } from '../../constants';
import GlossaryMixin from '../../mixins/glossary.mixin';

export default {
  mixins: [GlossaryMixin],
  name: 'GlossaryItems',
  props: {
    expandedItems: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      expandedPanels: [],
    };
  },
  watch: {
    expandedItems() {
      this.expandedPanels = this.expandedItems;
    },
    expandedPanels() {
      this.$emit('update:expandedItems', this.expandedPanels);
    },
  },
  mounted() {
    this.expandedPanels = this.expandedItems;
  },
  methods: {
    handleClickPanel(contentId) {
      const index = this.glossaries.findIndex(content => content.id === contentId);
      if (this.expandedPanels.includes(index)) {
        window.analytics.track(SEGMENT_EVENTS.COLLAPSE_GLOSSARY_ITEM, {
          contentTitle: this.glossaries[index].name,
          contentId,
          contentType: 'Glossary',
        });
      } else {
        window.analytics.track(SEGMENT_EVENTS.EXPAND_GLOSSARY_ITEM, {
          contentTitle: this.glossaries[index].name,
          contentId,
          contentType: 'Glossary',
        });
      }
    },
  },
};
</script>

<style scoped>
.card-root .panel:nth-child(2)::after {
  border: 0;
}
.panel::after {
  margin: 0rem 1.5rem;
}
.glossary,
.glossary .v-expansion-panel::before,
.glossary >>> .v-expansion-panel {
  box-shadow: none !important;
}
.glossary .glossary__index {
  font-weight: bold;
  font-size: 2rem;
  line-height: 2.4375rem;
  letter-spacing: 0.0063rem;
  color: #234025;
  flex: 1;
}
.card-title-container >>> span.v-btn__content {
  font-weight: 800 !important;
}
.glossary .glossary__title {
  font-weight: 600;
  font-size: 0.9375rem;
  line-height: 1.125rem;
  letter-spacing: 0.0063rem;
  color: var(--v-primary-base);
}
.glossary >>> .expansion-panel-title {
  font-size: 0.875rem;
  font-weight: 600px;
  color: var(--v-primary-base);
}
.glossary >>> .expansion-panel-content {
  font-size: 0.875rem;
  color: #424540bd;
  font-weight: 400;
}
.expansion-panel-content >>> .aligncenter {
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.expansion-panel-content >>> .alignright {
  float: right;
  margin: 0.5em 0 0.5em 1em;
}
.expansion-panel-content >>> .alignleft {
  float: left;
  margin: 0.5em 1em 0.5em 0;
}
.glossary .glossary__search-result {
  font-size: 1.25rem;
  line-height: 1.5rem;
  letter-spacing: 0.0063rem;
  color: #234025;
  padding-bottom: 1rem;
  background-color: #fff;
  text-align: left;
  width: 100%;
  padding: 1.25rem;
  padding-left: 0.9375rem;
}
.glossary .v-expansion-panel {
  margin-top: 0 !important;
}
.glossary .v-expansion-panels .glossary__panel-main.first-panel:after {
  border: 0 !important;
}
.glossary .card-root {
  border-bottom: 0.0625rem solid #ccd3de;
}
</style>
